import { Component, OnInit, SimpleChanges, OnChanges, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexMarkers,
  ApexNoData,
  ApexStroke,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ChartComponent,
} from 'ng-apexcharts';
import * as moment from 'moment';
import { ResearchPortalBdService } from '../../../../services/research-portal-bd.service';
import { AccountService } from '../../../../services/account.service';

export interface ChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  fill: ApexFill;
  stroke: ApexStroke;
  markers: ApexMarkers;
  colors: string[];
  noData: ApexNoData;
  tooltip: ApexTooltip;
  grid: ApexGrid;
}

@Component({
  selector: 'app-rsi-graph',
  templateUrl: './rsi-graph.component.html',
  styleUrls: ['./rsi-graph.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RsiGraphComponent implements OnInit, OnChanges {
  @Input() selectedCompany;
  @Input() fromDate;
  @Input() toDate;
  graphDataSet = null;
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions1: Partial<ChartOptions>;
  darkMode;
  constructor(
    private researchPortalService: ResearchPortalBdService,
    private cdRef: ChangeDetectorRef,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    // this.accountService.switchTheme.subscribe((themeMode) => {
    //   if (themeMode !== null) {
    //     this.darkMode = themeMode;
    //     this.getGraphData(this.graphDataSet);
    //     this.cdRef.detectChanges();
    //   }
    // });
    this.accountService.emitChange.subscribe(async (status) => {
      // console.log('rsi')
      if (status != null && this.graphDataSet) {
        await this.getGraphData(null);
        setTimeout(async () => {
          await this.getGraphData(this.graphDataSet);
        }, 10);
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.selectedCompany && this.fromDate && this.toDate) {
      try {
        this.graphDataSet = null;
        let data = await this.researchPortalService.getRSIData(
          moment(this.toDate).format('YYYY-MM-DD'),
          moment(this.fromDate).format('YYYY-MM-DD'),
          this.selectedCompany.companyName
        );

        this.graphDataSet = data;
        if (data) {
          await this.getGraphData(data);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  async getGraphData(data) {
    console.log(data?.rsi);
    const roundedRSI = data?.rsi.map((x) => parseFloat(x.toFixed(4)));

    this.chartOptions1 = {
      series: [
        {
          name: 'RSI Graph',
          type: 'line',
          color: '#7C3AED',
          data: roundedRSI,
          // data: [33.333333333333336, 33.33333333333333, 33.333],
          // data: data?.rsi,
        },
      ],
      chart: {
        fontFamily: 'Inter, Arial, sans-serif',
        id: 'chart2',
        type: 'line',
        height: 350,
        toolbar: {
          autoSelected: 'pan',
          show: false,
        },
      },
      // colors: ['#546E7A'],
      stroke: {
        curve: 'straight',
        width: 2,
      },
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        inverseOrder: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          let toolData = { y: w.globals.initialSeries[seriesIndex].data[dataPointIndex], x: w.config.xaxis.categories[dataPointIndex] };
          toolData.x = moment(toolData.x).format('MM/DD/YYYY');
          toolData.y = Number(toolData.y).toFixed(2);
          return (
            '<div class="tootTipBox"><b>' + toolData.x + ' </b>' + '<div><span>RSI Value: <b>' + toolData.y + '</b></span></div>' + '</div>'
          );
        },
        fillSeriesColor: false,
        x: {
          show: true,
          format: 'dd-MM-yy',
          formatter: function (v) {
            return moment(v).format('YYYY-MM-DD');
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        opacity: 1,
      },
      markers: {
        size: 0,
      },
      xaxis: {
        type: 'datetime',
        categories: data?.dates,
        labels: {
          format: 'dd/MM',
          style: {
            colors: this.darkMode ? '#bab8c5' : '#374151',
          },
        },
      },
      yaxis: {
        decimalsInFloat: 0,
        labels: {
          style: {
            colors: this.darkMode ? '#bab8c5' : '#374151',
          },
        },
        tooltip: {
          enabled: true,
          offsetX: 0,
        },
      },
      grid: {
        borderColor: this.darkMode ? '#1e293b' : '#e5e7eb',
      },
    };
    this.cdRef.detectChanges();
  }
}
